import DayItem from "/components/shared/DayItem";
import React, {useContext} from "react";
import {DateTime} from 'luxon';
import NoEventsView from "/components/shared/NoEventsView";
import {groupShowsByDay} from '/utils';
import AppContext from "/context/AppContext";


export default function ShowsContainer({shows}) {
    const {productions} = useContext(AppContext);
    let showsGroupedByDay = groupShowsByDay(shows);

    const showViews = Object.entries(showsGroupedByDay).map(([key, shows]) => {
        return (
            <div
                key={key}
                className='h-fit'>
              <DayItem
                linkTitle={true}
                    day={DateTime.fromISO(key)}
                    shows={shows}
                />
            </div>
        );
    });

    if (showViews.length === 0) {
        return <NoEventsView/>;
    }
    return (
        <div className="p-4 md:p-8">
          {showViews}
        </div>
    );
}
